import { render } from "./HRReviewForm.vue?vue&type=template&id=79d74d18&scoped=true"
import script from "./HRReviewForm.vue?vue&type=script&lang=js"
export * from "./HRReviewForm.vue?vue&type=script&lang=js"

import "./HRReviewForm.vue?vue&type=style&index=0&id=79d74d18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79d74d18"]])

export default __exports__